export default "07579c30530a6bbd.svg"